/**
 * Formattiamo il campo in modo che sia più leggibile
 * (e.g. "nomeCognomeUtente titolare" -> "Nome Cognome Utente Titolare")
 */
export function camelCaseToWords(str: string) {
  return (str.match(/(?:\b\w|[A-Z])[^A-Z\W]*/g) ?? [])
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
